import React, { Component } from 'react';
import axios from "axios";
import Layout from "./Components/Layout";

export class Inventory extends Component {
    state = {
        inventory: [],
        isLoading: true,
        error: null,
        totalItems: 0
    }

    componentDidMount() {
        this.fetchInventory();
    }

    fetchInventory = () => {
        this.setState({ isLoading: true, error: null });
        
        // For now, simulate API call - replace with actual endpoint when available
        setTimeout(() => {
            this.setState({ 
                isLoading: false, 
                error: null,
                inventory: [],
                totalItems: 0
            });
        }, 1000);

        // Uncomment when API endpoint is ready
        /*
        axios.get('inventory/parts')
            .then(response => {
                this.setState({
                    inventory: response.data.inventory || [],
                    totalItems: response.data.total || 0,
                    isLoading: false,
                    error: null
                });
            })
            .catch(error => {
                console.error('Error fetching inventory:', error);
                this.setState({
                    error: "Failed to fetch",
                    isLoading: false,
                    inventory: [],
                    totalItems: 0
                });
            });
        */
    }

    render() {
        const { inventory, isLoading, error, totalItems } = this.state;

        return (
            <Layout>
                <div style={{ height: 'calc(100vh - 70px)', overflow: 'hidden', paddingTop: '20px' }}>
                    <section className="section pb-0" style={{ marginBottom: '0px', paddingTop: '20px', paddingBottom: '0px' }}>
                        <div className="container-fluid" style={{ paddingLeft: '24px' }}>
                            
                            {/* Header Section */}
                            <div style={{ marginBottom: '32px' }}>
                                <p style={{ 
                                    color: '#6b7280', 
                                    fontSize: '16px', 
                                    margin: 0 
                                }}>
                                    Manage inventory levels and stock
                                </p>
                            </div>

                            {/* Parts Inventory Section */}
                            <div style={{ 
                                background: 'white', 
                                borderRadius: '12px', 
                                border: '1px solid #e5e7eb',
                                overflow: 'hidden'
                            }}>
                                <div style={{ 
                                    padding: '24px', 
                                    borderBottom: '1px solid #e5e7eb' 
                                }}>
                                    <h2 style={{ 
                                        fontSize: '16px', 
                                        fontWeight: '600', 
                                        color: '#111827',
                                        margin: 0 
                                    }}>
                                        Parts Inventory
                                    </h2>
                                </div>

                                {/* Error Message */}
                                {error && (
                                    <div style={{ 
                                        margin: '24px',
                                        padding: '16px',
                                        backgroundColor: '#fef2f2',
                                        border: '1px solid #fecaca',
                                        borderRadius: '8px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px'
                                    }}>
                                        <div style={{
                                            width: '20px',
                                            height: '20px',
                                            borderRadius: '50%',
                                            backgroundColor: '#dc2626',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: 'white',
                                            fontSize: '12px',
                                            fontWeight: 'bold'
                                        }}>
                                            !
                                        </div>
                                        <span style={{ 
                                            color: '#dc2626', 
                                            fontSize: '14px',
                                            fontWeight: '500'
                                        }}>
                                            {error}
                                        </span>
                                    </div>
                                )}

                                {/* Table */}
                                <div style={{ overflow: 'hidden' }}>
                                    <table style={{ 
                                        width: '100%', 
                                        borderCollapse: 'collapse' 
                                    }}>
                                        <thead>
                                            <tr style={{ 
                                                backgroundColor: '#f9fafb',
                                                borderBottom: '1px solid #e5e7eb'
                                            }}>
                                                <th style={{ 
                                                    padding: '16px 24px', 
                                                    textAlign: 'left',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    color: '#6b7280',
                                                    border: 'none'
                                                }}>
                                                    Part Number
                                                </th>
                                                <th style={{ 
                                                    padding: '16px 24px', 
                                                    textAlign: 'left',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    color: '#6b7280',
                                                    border: 'none'
                                                }}>
                                                    Name
                                                </th>
                                                <th style={{ 
                                                    padding: '16px 24px', 
                                                    textAlign: 'left',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    color: '#6b7280',
                                                    border: 'none'
                                                }}>
                                                    Standard Cost
                                                </th>
                                                <th style={{ 
                                                    padding: '16px 24px', 
                                                    textAlign: 'left',
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                    color: '#6b7280',
                                                    border: 'none'
                                                }}>
                                                    Unit of Measure
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {isLoading ? (
                                                <tr>
                                                    <td colSpan="4" style={{ 
                                                        padding: '48px 24px', 
                                                        textAlign: 'center',
                                                        color: '#6b7280',
                                                        border: 'none'
                                                    }}>
                                                        <div style={{ 
                                                            display: 'flex', 
                                                            alignItems: 'center', 
                                                            justifyContent: 'center',
                                                            gap: '12px'
                                                        }}>
                                                            <div style={{
                                                                width: '20px',
                                                                height: '20px',
                                                                border: '2px solid #e5e7eb',
                                                                borderTop: '2px solid #3b82f6',
                                                                borderRadius: '50%',
                                                                animation: 'spin 1s linear infinite'
                                                            }}></div>
                                                            Loading inventory...
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : inventory.length === 0 ? (
                                                <tr>
                                                    <td colSpan="4" style={{ 
                                                        padding: '48px 24px', 
                                                        textAlign: 'center',
                                                        color: '#6b7280',
                                                        fontSize: '16px',
                                                        border: 'none'
                                                    }}>
                                                        No parts found
                                                    </td>
                                                </tr>
                                            ) : (
                                                inventory.map((item, index) => (
                                                    <tr key={index} style={{ 
                                                        borderBottom: index < inventory.length - 1 ? '1px solid #f3f4f6' : 'none',
                                                        cursor: 'pointer'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = '#f9fafb';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = 'transparent';
                                                    }}>
                                                        <td style={{ 
                                                            padding: '16px 24px',
                                                            fontSize: '14px',
                                                            color: '#111827',
                                                            border: 'none'
                                                        }}>
                                                            {item.partNumber}
                                                        </td>
                                                        <td style={{ 
                                                            padding: '16px 24px',
                                                            fontSize: '14px',
                                                            color: '#111827',
                                                            border: 'none'
                                                        }}>
                                                            {item.name}
                                                        </td>
                                                        <td style={{ 
                                                            padding: '16px 24px',
                                                            fontSize: '14px',
                                                            color: '#111827',
                                                            border: 'none'
                                                        }}>
                                                            {item.standardCost}
                                                        </td>
                                                        <td style={{ 
                                                            padding: '16px 24px',
                                                            fontSize: '14px',
                                                            color: '#111827',
                                                            border: 'none'
                                                        }}>
                                                            {item.unitOfMeasure}
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                {/* CSS Animation */}
                <style jsx>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </Layout>
        );
    }
}

export default Inventory;